import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"search\"><path d=\"m13.787 12.752-3.45-3.466a5.52 5.52 0 0 0 1.372-3.634C11.71 2.536 9.08 0 5.852 0S0 2.536 0 5.652s2.626 5.653 5.855 5.653a5.93 5.93 0 0 0 3.354-1.023l3.474 3.492a.77.77 0 0 0 .55.226c.2 0 .387-.073.53-.206a.72.72 0 0 0 .02-1.042zM5.855 1.475c2.386 0 4.327 1.874 4.327 4.177 0 2.304-1.94 4.178-4.327 4.178S1.527 7.956 1.527 5.652s1.942-4.177 4.328-4.177\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol